/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import kitsu from '@plugins/kitsu';
let $ajax;
export const state = {
  detail: null,
};

export const mutations = {
  SET_DETAIL(state, newValue) {
    state.detail = newValue;
  },
};
export const actions = {
  async index({ commit }, reset) {
    if (state.detail && !reset) return Promise.resolve(state.detail);
    const detail = await http.get('psp/gtk/ptk').then(({ data }) => data);
    commit('SET_DETAIL', detail);
    return Promise.resolve(detail);
  },

  // eslint-disable-next-line no-empty-pattern
  uploadFoto({}, payload) {
    const url = `psp/gtk/ptk/foto`;
    return http.post(url, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  mulaiTbs({}, payload) {
    const url = `psp/gtk/profil/${payload.id}/tbs/mulai/${payload.tbsId}`;
    return http.post(url);
  },

  password({}, params) {
    return http.post(`psp/gtk/ptk/password`, params).then(({ data }) => data);
  },

  ajuan({}, id) {
    return http.post(`psp/gtk/profil/${id}/ajuan`).then(({ data }) => data);
  },

  batalAjuan({}, id) {
    return http.post(`psp/gtk/profil/${id}/batal-ajuan`).then(({ data }) => data);
  },

  batalDaftar({}, payload) {
    return http
      .post(`psp/gtk/${payload.tipe === 'pa' ? 'pelatih-ahli' : 'peserta'}-pendaftaran/batal`, payload.params)
      .then(({ data }) => data);
  },

  simulasi({}, payload) {
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/gtk/profil/${payload.id}/simulasi`,
    });
    return $ajax.get('/', { params: payload.params });
  },

  simulasiPa({}, payload) {
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/gtk/pelatih-ahli/simulasi/${payload.id}`,
    });
    return $ajax.get('/', { params: payload.params });
  },

  getRpp({}, payload) {
    const url = `psp/gtk/profil/${payload.id}/simulasi/rpp`;
    return http.get(url).then(({ data }) => data);
  },

  konfirmasiSm({}, payload) {
    const url = `psp/gtk/profil/${payload.id}/simulasi/konfirmasi`;
    return http.post(url, payload.params);
  },

  konfirmasiRpp({}, payload) {
    const url = `psp/gtk/profil/${payload.id}/simulasi/update-rpp`;
    return http.post(url, payload.params);
  },

  konfirmasiSap({}, payload) {
    const url = `psp/gtk/pelatih-ahli/simulasi/${payload.id}/save-sap`;
    return http.post(url, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  actions({}, payloads) {
    return http
      .post(`psp/gtk/profil/${payloads.id}/${payloads.action}`, payloads.params, payloads.config || {})
      .then(({ data }) => data);
  },
};
